import { LoadableAfterPaint } from '@confluence/loadable';

/**
 * Deprecated - This file will be removed in the future. Please reach out to #cc-virality for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */
export {
	ChangeEditionInlineDialogLoader,
	ChangeEditionInlineDialogPaintLoader,
} from './InlineDialog';
export { ChangeEditionLegacyCoordinator } from './LegacyCoordinator/ChangeEditionLegacyCoordinator';
export { withIsSiteAdmin } from './higher-order';
export type { WithIsSiteAdminProps } from './higher-order';
export { SECTION_MESSAGE_APPEARANCE_TYPES } from './constants';

export const UpgradeEditionButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UpgradeEditionButton" */ './Upgrade/UpgradeEditionButton'
			)
		).UpgradeEditionButton,
});

export const LearnMoreButton = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LearnMoreButton" */ './Upgrade/LearnMoreButton'))
			.LearnMoreButton,
});
